import { connect } from 'react-redux';
import compose from 'recompose/compose';
import {
  getOrderSummary,
  getVehicle,
  getCustomerIsGreen,
  getContracts2crPhase2
} from '../../../../../../ducks/selectors';
import { getMarketing, getRescheduleModal } from '../../ducks/selector';
import ReschedulerModal from './rescheduler-modal';

const mapStateToProps = state => ({
  marketing: getMarketing(state),
  orderSummary: getOrderSummary(state),
  rescheduleModal: getRescheduleModal(state),
  vehicle: getVehicle(state),
  customerIsGreen: getCustomerIsGreen(state),
  isContractToCRPhase2: getContracts2crPhase2(state)
});

export default compose(connect(mapStateToProps))(ReschedulerModal);
